<template>
  <div>
    <article>
      <header>
        <h2>{{ $t("upcomingTitle") }}</h2>
      </header>
      <main>
        <table cellspacing="0">
          <tr
            v-for="(entry, index) in SAVE_THE_DATE.dates"
            :key="index"
            :class="{ upcoming: !entry.date }"
          >
            <td style="font-variant: tabular-nums; white-space: nowrap">
              <p>
                <i18n tag="strong" path="dateFormat.full" v-if="entry.date">
                  <template #day>{{ entry.date.day }}</template>
                  <template #monthName>{{
                    $t(`monthNames[${entry.date.month - 1}]`)
                  }}</template>
                  <template #year>{{ entry.date.year }}</template>
                </i18n>
                <strong v-else> TBD </strong>
              </p>
            </td>
            <td>
              <p>
                <strong>{{ $dt(entry.title) }}</strong
                ><br />
                {{ $dt(entry.description) }}
              </p>
            </td>
          </tr>
        </table>
      </main>
    </article>
    <article class="calendar-wrapper">
      <header>
        <h1>
          {{ $t(`monthNames[${SAVE_THE_DATE.calendar.month - 1}]`) }}
          {{ SAVE_THE_DATE.calendar.year }}
        </h1>
      </header>
      <main class="calendar">
        <div class="header" v-for="day in 7" :key="`header-${day}`">
          {{ $t(`weekdaysShort[${day - 1}]`) }}
        </div>
        <div
          class="day"
          v-for="idx in 41"
          :key="`day-${idx}`"
          :class="[
            {
              inMonth: dayInMonth(idx),
            },
            ...dayClasses(idx),
          ]"
          :style="{
            'animation-delay': `${idx}s`,
          }"
        >
          <div>
            {{ displayDay(idx) }}
          </div>
          <div
            style="font-weight: bold"
            v-for="(event, index) in eventsInCalendarTile[idx]"
            :key="index"
          >
            {{ event.title }}
          </div>
        </div>
      </main>
    </article>
    <div class="timetable">
      <PartyAgenda
        v-for="party in PARTIES"
        :accentClass="party.accentClass"
        :title="party.title"
        :date="party.date"
        :location="party.location"
        :events="party.events"
        :remarks="party.remarks"
      />
    </div>
    <div class="save-the-date" v-if="nextPartyDate">
      <article>
        <header>
          <h3>Save the Date</h3>
        </header>
        <main>
          <i18n
            tag="p"
            :path="
              ticketSaleStartAvailable
                ? 'saveTheDate'
                : 'saveTheDateWithoutSale'
            "
          >
            <template v-slot:nextPartyDay>{{ nextPartyDate.day }}</template>
            <template v-slot:nextPartyMonth>{{
              $t(`monthNames[${nextPartyDate.month - 1}]`)
            }}</template>
            <template v-slot:nextPartyYear>{{ nextPartyDate.year }}</template>
            <template v-slot:ticketSaleStartDay>{{
              ticketSaleStart.day
            }}</template>
            <template v-slot:ticketSaleStartMonth>{{
              $t(`monthNames[${ticketSaleStart.month - 1}]`)
            }}</template>
            <template v-slot:ticketSaleStartYear>{{
              ticketSaleStart.year
            }}</template>
            <template v-slot:ticketSaleStartHour>{{
              ticketSaleStart.hour
            }}</template>
          </i18n>
        </main>
      </article>
    </div>
  </div>
</template>

<script>
import PARTIES from "@/data/parties.yml";
import SAVE_THE_DATE from "@/data/save-the-date.yml";
import PartyAgenda from "@/components/PartyAgenda";
import dynamicLocalization from "../mixins/dynamic-localization";

export default {
  components: { PartyAgenda },
  mixins: [dynamicLocalization],
  data() {
    const nextPartyDate = JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE);
    const ticketSaleStart = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);

    const ticketSaleStartAvailable =
      nextPartyDate.year > ticketSaleStart.year ||
      nextPartyDate.month > ticketSaleStart.month ||
      nextPartyDate.day > ticketSaleStart.day;

    return {
      nextPartyDate,
      ticketSaleStart,
      ticketSaleStartAvailable,
      eventClasses: [
        "accent-panda accent-didi",
        "accent-volth",
        "accent-patricia",
      ],
      PARTIES,
      SAVE_THE_DATE,
    };
  },
  computed: {
    eventsInCalendarTile() {
      let calendarTiles = [];

      for (let i = 0; i < 42; i++) {
        calendarTiles.push([]);
      }

      this.SAVE_THE_DATE.calendar.events.map((event) => {
        calendarTiles[this.firstDayOffset + event.day].push(event);
      });

      return calendarTiles;
    },
    firstOfMonth() {
      return new Date(
        this.SAVE_THE_DATE.calendar.year,
        this.SAVE_THE_DATE.calendar.month - 1,
        1
      );
    },
    firstDayOffset() {
      return this.firstOfMonth.getDay() - 1;
    },
    lastOfMonth() {
      return new Date(
        this.SAVE_THE_DATE.calendar.year,
        this.SAVE_THE_DATE.calendar.month,
        0
      );
    },
  },
  methods: {
    dayHasEvent(day) {
      return false;
      // return this.eventDates.some((date, idx) => {
      //   return this.displayDay(idx, week, day) === date.getDate();
      // });
    },
    dayClasses(idx) {
      return this.eventsInCalendarTile[idx].map((event) => {
        return event.accent;
      });
    },
    dayInMonth(idx) {
      return (
        idx > this.firstDayOffset &&
        idx <= this.lastOfMonth.getDate() + this.firstDayOffset
      );
    },
    displayDay(idx) {
      if (idx < 7 && idx < this.firstOfMonth.getDay()) {
        return null;
      }

      let dayOffset = idx - this.firstDayOffset;

      if (dayOffset > this.lastOfMonth.getDate()) {
        return null;
      }

      return dayOffset;
    },
    weekDayLocalized(day) {
      return ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"][day - 1];
    },
  },
};
</script>

<style scoped lang="scss">
$colorMain: #1976d2;
$colorAccent: #fdd835;
$colorPatricia: #f06292;

$accentColors: (
  "didi": $colorMain,
  "patricia": $colorPatricia,
  "volth": $colorAccent,
  "panda": #00963d,
);

@function contrast-color($color, $dark: #000, $light: #fff, $threshold: 55%) {
  @return if(lightness($color) < $threshold, $light, $dark);
}

article.calendar-wrapper {
  background: $colorAccent;

  @media screen and (max-width: 1000px) {
    display: none;
  }

  > header {
    text-align: center;
  }

  > main {
    padding: 8px;
  }

  > main.calendar {
    // background: white;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 12px;

    .day {
      aspect-ratio: 6/4;
      padding: 6px;
      background-color: rgba(white, 0.5);
      border-radius: 6px;
      opacity: 0.3;
      color: black;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 80%;

      &.inMonth {
        opacity: 1;
      }

      @each $name, $color in $accentColors {
        &.accent-#{$name} {
          background: $color;
          color: contrast-color($color);
        }

        @each $name2, $color2 in $accentColors {
          @if $name != $name2 {
            &.accent-#{$name}.accent-#{$name2} {
              background: linear-gradient(-30deg, $color2 20%, $color 80%);
            }
          }
        }
      }
    }

    .party {
      position: relative;
      background: white;
      box-shadow: 0 2px 12px rgba(black, 0.4);

      > * {
        position: relative;
        z-index: 2;
        color: black;
      }

      // &:before {
      //   $scale: 20%;
      //   content: '';
      //   position: absolute;
      //   top: -$scale;
      //   left: -$scale;
      //   right: -$scale;
      //   bottom: -$scale;
      //   background: rgba(white, 0.6);
      //   border-radius: 100%;
      //   transform: rotate(-10deg);
      //   z-index: 1;
      // }
    }

    .header {
      background-color: transparent;
      margin-left: 8px;
      font-weight: bold;
    }

    @media screen and (max-width: 720px) {
      display: none;
    }
  }
}

.timetable {
  float: left;
  margin-top: -600px;
  margin-left: -40px;
  z-index: 100;
  color: white;
  position: relative;
  display: block;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-right: 20px;
  width: 50%;

  > div {
    margin-top: 2em;

    &:first-child {
      margin-top: 0;
    }
  }

  > article {
    position: relative;

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: -1;
      border-radius: 8px;
      background-color: rgba(black, 0.6);

      @media screen and (max-width: 1200px) {
        backdrop-filter: none;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    float: none;
    margin: 0;
    width: 100%;
    box-sizing: border-box;
  }
}

.save-the-date {
  float: right;
  width: 40%;

  @media screen and (max-width: 1200px) {
    width: 100%;
    float: none;
  }
}

table {
  tr td {
    border-bottom: 1px solid rgba(white, 0.2);
    padding: 10px;
    vertical-align: top;

    &:first-child {
      padding-left: 0;
      white-space: nowrap;
    }

    &:last-child {
      padding-right: 0;
    }

    @media screen and (max-width: 1000px) {
      display: block;
      border-bottom: none;
    }
  }

  tr:last-child td {
    border-bottom: 0;
  }

  tr.upcoming {
    opacity: 0.5;
  }
}
</style>
<i18n>
{
  "de": {
    "saveTheDate": "Die nächste Party findet am {nextPartyDay}. {nextPartyMonth} {nextPartyYear} statt - der Ticketverkauf startet am {ticketSaleStartDay}. {ticketSaleStartMonth} {ticketSaleStartYear} um {ticketSaleStartHour} Uhr!",
    "saveTheDateWithoutSale": "Die nächste Party findet am {nextPartyDay}. {nextPartyMonth} {nextPartyYear} statt - der Start des Ticketverkaufs wird rechtzeitig vorher bekanntgeben!",
    "upcomingTitle": "Termine und Fristen",
    "dateFormatWithWeekday": "{weekday}, {day}. {monthName} {year}"
  },
  "en": {
    "saveTheDate": "The next party takes place on {nextPartyMonth} {nextPartyDay}, {nextPartyYear} - ticket sales start on {ticketSaleStartMonth} {ticketSaleStartDay}, {ticketSaleStartYear}, {ticketSaleStartHour}.00!",
    "saveTheDateWithoutSale": "The next party takes place on {nextPartyMonth} {nextPartyDay}, {nextPartyYear} - start of ticket sales will be announced as soon as possible.",
    "upcomingTitle": "Dates and Deadlines",
    "dateFormatWithWeekday": "{weekday}, {monthName} {day}, {year}"
  }
}
</i18n>
<i18n src="@/locales/global.json" />
